import {Observable} from 'rxjs';
import {RestQueryParams} from '../base/queryParams';
import {marineHubAPI} from '../provider/marineHubAPI';

export function changePasswordAPI(oldPassword: string, newPassword: string, accessToken: string): Observable<any> {
    return marineHubAPI.post(
        'api/users/change_password',
        {
            oldPassword: oldPassword,
            newPassword: newPassword,
        },
        new RestQueryParams(),
        {
            Authorization: `Bearer ${accessToken}`,
        }
    );
}
